import React from 'react';
import Service1 from '../assets/ServicesImg/DigitalService.jpg';
import Service2 from '../assets/ServicesImg/ConsultingService.jpg';
import Service3 from '../assets/ServicesImg/TechnologyService.jpg';
import { Link } from 'react-router-dom';
import './ServiceSection.css';

const services = [
  {
    to: '/digital',
    src: Service1,
    label: 'Digital Transformation',
    title: 'Digital',
    text: 'Innovative solutions for digital transformation, application development, and emerging technologies.',
  },
  {
    to: '/consulting',
    src: Service2,
    label: 'Strategic Advisory',
    title: 'Advisory & Consulting',
    text: 'Strategic advisory for business transformation, innovation, and sector-specific solutions.',
  },
  {
    to: '/technology',
    src: Service3,
    label: 'Modern Engineering',
    title: 'Technology',
    text: 'Advanced engineering with DevOps, cloud adoption, automation, and modern application development.',
  },
];

function ServiceSection() {
  return (
    <section className="service-showcase container-fluid" data-aos="fade-up" data-aos-anchor-placement="top-center">
      <div className="heading mx-2 service-heading" data-aos="fade-up" data-aos-anchor-placement="top-center">
        <h5 className="text-primary mt-4"><b>SERVICES</b></h5>
        <p className="ser-content mx-auto my-3 hcs hf" style={{ color: 'var(--content_color)' }}>
          Transform your business with Us
        </p>
      </div>

      <div className="row service-grid px-4">
        {services.map((service, index) => (
          <div 
            className="col-12 col-md-4 p-3"
            data-aos="fade-up"
            data-aos-delay={index * 100}
            data-aos-anchor-placement="top-center"
            key={service.title}
          >
            <Link to={service.to} className="service-tile">
              <article className="service-card">
                <div className="service-card-topline">
                  <span>{service.label}</span>
                </div>

                <div className="service-media-frame">
                  <img loading="lazy" src={service.src} alt={service.title} />
                </div>

                <div className="service-card-body">
                  <h4>{service.title}</h4>
                  <p>{service.text}</p>
                </div>

                <div className="service-card-action">
                  <span>Explore service</span>
                  <span aria-hidden="true">→</span>
                </div>
              </article>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServiceSection;
